import { render, staticRenderFns } from "./AlbumShareModal.vue?vue&type=template&id=3b055546&scoped=true"
import script from "./AlbumShareModal.vue?vue&type=script&lang=ts"
export * from "./AlbumShareModal.vue?vue&type=script&lang=ts"
import style0 from "./AlbumShareModal.vue?vue&type=style&index=0&id=3b055546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b055546",
  null
  
)

export default component.exports